import { Helmet } from 'react-helmet-async';

interface CanonicalTagProps {
  url: string;
}

export const CanonicalTag = ({ url }: CanonicalTagProps) => {
  const fullUrl = url.startsWith('http') ? url : `https://sinkbikerun.com${url}`;
  
  return (
    <Helmet>
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};
